import { Api, fetchData } from './api';
import { AppConfig, config } from './AppConfig';
import { createApp } from 'InternalLibrary';
import i18n from 'i18next';

import './datadog/init';
import { spacesSanitizer } from './utils/sanitizers';

export const App = createApp<Api, AppConfig>({
  fetch: fetchData,
  config,
  translateError: (app, error) =>
    i18n.t(`notification:${error}`, {
      phone: config.phoneNumber,
      'phone-no-spaces': spacesSanitizer(config.phoneNumber),
    }),
  colaUrl: import.meta.env.VITE_COLA_URL || '',
});
